import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate } from '@angular/router';


@Injectable()
export class ErrorInterceptor {

    canActivate(prev: ActivatedRouteSnapshot, next: RouterStateSnapshot) {
        let params = next.url.split('/');
        return true;
    }

    public checkValidLanguage(lang:string){
        if(lang == 'es' || lang == 'en' || lang == 'fr' || lang == 'it' || lang == 'de'){
            return true;
        }else{
            return false;
        }
    }
}